module.exports = __webpack_public_path__ + "img/trash.f5dcde90.svg";